import styled from '@emotion/styled';
import { Button as CommonButton, Icon as CommonIcon } from '@pairy/pds-react';
import { theme } from '@pairy/styles';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const Button = styled(CommonButton)`
  width: auto;
  height: 59px;
  opacity: ${VIEWER_Z_INDEX.desktopLayer};
  transition: opacity 0.15s ease-in-out, width 0.15s ease-in-out;

  &.disable {
    cursor: initial;
    opacity: 0.25;

    &:hover {
      border-color: ${theme.colors.zinc_200};
      background-color: ${theme.colors.white};
      color: ${theme.colors.zinc_400};
    }
  }
`;

export const Icon = styled(CommonIcon)`
  margin: 4px;
`;
